<section class="w3l-form-25">
    <div class="form-inner-cont">
        <div class="w3l-form-25">
            <h1>Doctors Master Data</h1>
            <p>Enter Doctors Master Data below to stay updated </p>
        </div>
    </div>
</section>
<section class="w3l-hero-headers-11 p-sticky-md">
    <div class="top-header">
        <div class="d-grid grid-columns-top-3">
            <div class="accounts">
                <ul>
                    <li></li>
                    <li></li>
                </ul>
            </div>

        </div>
    </div>
</section>


<div id="w3l-appointment">
  <section class="appointment-section section-gap">
    <div class="wrapper">
        <div class="d-grid doctor-appointment">
            <div class="appointment-form">
                <form action="#" method="post">
                    <div class="fields-grid">
                      <div class="styled-input">
                        <label>Doctor ID</label>
                        <div class="appointment-form-field">
                            <span class="fa fa-search" aria-hidden="true" (click)="openDialog()" style="cursor: grab;"></span>
                            <input type="text" name="doctorId" [(ngModel)]="docCode" maxlength="4ch" (change)="retriveDoctors()" id= "doctorId" placeholder="Doctor ID" required="" style="width: 30%;">
                        </div>
                      </div>
                      <div class="styled-input">
                            <label>Full Name</label>
                            <div class="appointment-form-field">
                                <span class="fa fa-user" aria-hidden="true"></span>
                                <input type="text" name="fullname" [(ngModel)]="docName" maxlength="50ch" Id="fullname" placeholder="Full Name" required="">
                            </div>
                      </div>
                        <div class="styled-input">
                          <label>Address</label>
                          <div class="appointment-form-field">
                              <span class="fa fa-map" aria-hidden="true"></span>
                              <input type="text" name="address" [(ngModel)]="docAddress" maxlength="100ch" docAddress ="address" placeholder="Address" required="">
                          </div>
                      </div>
                        <div class="styled-input">
                            <label>Phone Number</label>
                            <div class="appointment-form-field">
                                <span class="fa fa-phone" aria-hidden="true"></span>
                                <input type="text" name="phone" [(ngModel)]="docPhone" maxlength="50ch" id="phone" placeholder="Enter Number" required="">

                            </div>
                        </div>
                        <div class="styled-input">
                          <label>Mobile Number</label>
                          <div class="appointment-form-field">
                              <span class="fa fa-mobile" aria-hidden="true"></span>
                              <input type="text" name="mobile" [(ngModel)]="docMobile" maxlength="50ch" id="mobile" placeholder="Enter Mobile" required="">
                          </div>
                      </div>
                        <div class="styled-input">
                            <label>Department</label>
                            <div class="appointment-form-field">
                                <span class="fa fa-building-o" aria-hidden="true"></span>
                                <select id="department" name="department" required="" [(ngModel)]="docDepartment" [value]="docDepartment">
                                    <option value="">Specialization*</option>
                                    <option value="Oncology">Oncology</option>
                                    <option value="Pharmaceutical">Pharmaceutical</option>
                                    <option value="Pathology">Pathology</option>
                                    <option value="Psychology">Psychology</option>
                                    <option value="Internal Medicine">Internal Medicine</option>
                                    <option value="Surgery">Surgery</option>
                                    <option value="Pain Management">Pain Management</option>
                                    <option value="Gynecology">Gynecology</option>
                                    <option value="Nutrition">Nutrition</option>
                                    <option value="Cardiology">Cardiology</option>
                                    <option value="Rheumatology">Rheumatology</option>
                                    <option value="Others">Others</option>
                                </select>
                            </div>
                        </div>
                        <div class="styled-input">
                            <label>Work</label>
                            <div class="appointment-form-field">
                                <span class="fa fa-university" aria-hidden="true"></span>
                                <input type="text" name="Work" [(ngModel)]="docTitle" maxlength="50ch" id="Work" placeholder="Enter Work" required="">
                            </div>
                        </div>
                        <div class="styled-input">
                            <label>E-mail</label>
                            <div class="appointment-form-field">
                                <span class="fa fa-envelope-open" aria-hidden="true"></span>
                                <input type="email" name="mail"  [(ngModel)]="docmail" id="mail" maxlength="100ch" placeholder="Enter e-mail" required="">
                            </div>
                        </div>
                        <!------------- Accounting Informations  ------------>
                         <div class="styled-input">
                            <label>Fee</label>
                            <div class="appointment-form-field">
                                <span class="fa fa-money" aria-hidden="true"></span>
                                <input type="number" name="otherperc"   id="otherperc"  [(ngModel)]="otherperc" style="width: 32%;" placeholder="0" required="">
                                <label style="width: 5%;">L.E.</label>
                                 <label style="width: 5%;"></label>
                            </div>
                         </div>
                        <div class="styled-input">
                            <label>Doctor Share</label>
                            <label style="width: 33%;"></label>
                            <label>Medical Supervision %</label>
                            <div class="appointment-form-field">
                                <span class="fa fa-money" aria-hidden="true"></span>
                                <input type="number" name="patientfee"   id="patientfee"  [(ngModel)]="patientfee" style="width: 35%;" placeholder="0" required="">
                               <label style="width: 5%;">%</label>
                                <label style="width: 5%;"></label>

                                <span class="fa fa-percent" aria-hidden="true"></span>
                                <input type="number" name="supper"   id="supper" [(ngModel)]="supervisionperc" style="width: 35%;" max="100" placeholder="0" required="">
                                <label style="width: 5%;">%</label>
                            </div>
                        </div>
                        <div class="styled-input">
                            <label>Chemotherapy %</label>
                            <label style="width: 25%;"></label>
                            <label>Radiotherapy %</label>
                            <div class="appointment-form-field">
                                <span class="fa fa-percent" aria-hidden="true"></span>
                                <input type="number" name="chemoperc" [(ngModel)]="chemoperc"   id="chemoperc" style="width: 35%;" max="100"  placeholder="0" required="">
                                <label style="width: 5%;">%</label>
                                <label style="width: 5%;"></label>

                                <span class="fa fa-percent" aria-hidden="true"></span>
                                <input type="number" name="radioperc"   id="radioperc"  [(ngModel)]="radioperc" style="width: 35%;" max="100"  placeholder="0" required="">
                                <label style="width: 5%;">%</label>
                            </div>
                        </div>

                        <div class="styled-input">
                            <label>Consultant Hour : </label>
                            <input type="radio" name="time" value="Yes" checked required="" [(ngModel)]="docWmail"> Morning
                            <input type="radio" name="time" value="No" [(ngModel)]="docWmail"> Evening
                            <input type="radio" name="time" value="All" [(ngModel)]="docWmail"> All Day
                        </div>
                        <div class="styled-input">
                          <label>Doctor Status     : </label>
                          <input type="radio" name="DStatus" value="Yes" checked [(ngModel)]="docUser"> Active    
                          <input type="radio" name="DStatus" value="No" [(ngModel)]="docUser"> Non-Active
                      </div>
                        <!-- <button type="button" class="theme-button btn" (click)="submitDoctors()" name="submit">Submit</button>
                        <button type="button" class="theme-button btn" name="Delete" (click)="mesgDelete()">Delete</button>
                        <button type="button" class="theme-button btn" name="New" (click)="NewData()">New</button>
                        <a href="Home">
                        <button type="button" class="theme-button btn" style="width: 83%;" name="Back">Home</button>
                        </a> -->
                        <div class="clear"> </div>
                    </div>
                </form>
            </div>

            <div class="registerimg">
                <img src="assets/images/appnt.jpg" alt="" />
            </div>
        </div>
        <div class="clear" style="text-align: center;">
                        <button type="button" class="theme-button btn" (click)="submitDoctors()" name="submit">Submit</button>
                        <button type="button" class="theme-button btn" name="Delete" (click)="mesgDelete()">Delete</button>
                        <button type="button" class="theme-button btn" name="New" (click)="NewData()">New</button>
                        <a href="Home">
                        <button type="button" class="theme-button btn" name="Back">Home</button>
                        </a>
           </div>
    </div>
</section>
</div>

